import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CompanyService } from '@app-services/company.service';
import { createTree } from '@app-shared/utils';


interface CompanyCheckbox {
  id: string;
  label: string;
  checked: boolean;
  children?: CompanyCheckbox[];
  availableForEmployees?: boolean;
  availableForDependents?: boolean;
  availableForMinors?: boolean;
  indeterminate?: boolean;
  active?: boolean;
}

@Component({
    selector: 'app-company-form-checkbox',
    templateUrl: './company-form-checkbox.component.html',
    styleUrls: ['./company-form-checkbox.component.scss'],
    standalone: false
})
export class CompanyFormCheckboxComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  toogleAllModel = false;
  companiesOptions: CompanyCheckbox[] = [];

  constructor(
    private readonly configurationService: CompanyService,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.configurationService.getCompanies().subscribe((companies) => {
      const companiesSelected = new Map<string, CompanyCheckbox>();

      const value = this.formGroup.value;
      if (value.companiesPermissions && value.companiesPermissions.length > 0) {
        for (const c of value.companiesPermissions) {
          companiesSelected.set(c.id, c);
        }
      }

      const companiesTree = createTree(
        companies,
        'companyId',
        'parentCompanyId'
      );

      companies = companiesTree.map((c: any) => {
        const selected = companiesSelected.get(c.companyId);

        const checkbox: CompanyCheckbox = {
          id: c.companyId,
          label: c.companyName,
          checked: false,
          availableForDependents: selected
            ? selected.availableForDependents
            : false,
          availableForMinors: selected ? selected.availableForMinors : false,
          availableForEmployees: selected
            ? selected.availableForEmployees
            : false,
        };

        checkbox.checked =
          checkbox.availableForMinors &&
          checkbox.availableForDependents &&
          checkbox.availableForEmployees;
        checkbox.indeterminate =
          (checkbox.availableForMinors ||
            checkbox.availableForDependents ||
            checkbox.availableForEmployees) &&
          !checkbox.checked;

        checkbox.children = c.children.map((children) => {
          const childrenSelected = companiesSelected.get(children.companyId);
          const checkboxChildren: CompanyCheckbox = {
            id: children.companyId,
            label: children.companyName,
            checked: false,
            availableForDependents: childrenSelected
              ? childrenSelected.availableForDependents
              : false,
            availableForMinors: childrenSelected
              ? childrenSelected.availableForMinors
              : false,
            availableForEmployees: childrenSelected
              ? childrenSelected.availableForEmployees
              : false,
          };

          checkboxChildren.checked =
            checkboxChildren.availableForMinors &&
            checkboxChildren.availableForDependents &&
            checkboxChildren.availableForEmployees;

          checkboxChildren.indeterminate =
            (checkboxChildren.availableForMinors ||
              checkboxChildren.availableForDependents ||
              checkboxChildren.availableForEmployees) &&
            !checkboxChildren.checked;
          return checkboxChildren;
        });

        if (checkbox.children && checkbox.children.length > 0) {
          const master: CompanyCheckbox = {
            id: c.companyId,
            label: c.companyName,
            checked: false,
            availableForDependents: selected
              ? selected.availableForDependents
              : false,
            availableForMinors: selected ? selected.availableForMinors : false,
            availableForEmployees: selected
              ? selected.availableForEmployees
              : false,
          };
          master.checked =
            master.availableForMinors &&
            master.availableForDependents &&
            master.availableForEmployees;

          master.indeterminate =
            (master.availableForMinors ||
              master.availableForDependents ||
              master.availableForEmployees) &&
            !master.checked;
          checkbox.children.unshift(master);
        }
        return checkbox;
      });
      this.companiesOptions = companies;
      this.allToogled();
    });
  }

  onChangeMasterCompanyState(company: CompanyCheckbox, ref) {
    ref.checked = false;
    company.active = true;
    company.indeterminate = false;
    company.checked = false;

    if (company.children && company.children.length > 0) {
      const isForceState = !company.children.every(
        (children) => children.indeterminate || children.checked
      );
      for (const children of company.children) {
        this.changeStateSingleCompany(
          children,
          isForceState
            ? {
                colab: true,
                dependents: true,
              }
            : {
                colab: false,
                dependents: false,
                minor: false,
              }
        );
      }
      setTimeout(() => {
        company.checked = company.children.every(
          (children) => children.checked
        );
        company.indeterminate = company.children.some(
          (children) => children.indeterminate && !company.checked
        );
        ref.checked = company.checked;
      }, 0);
      this._onChange();
      return;
    }
    this.changeStateSingleCompany(company);
    ref.checked = company.checked;
    this._onChange();
  }

  onChangeChildrenCompanyState(
    company: CompanyCheckbox,
    refChildren,
    master: CompanyCheckbox,
    refMaster
  ) {
    refChildren.checked = false;
    this.changeStateSingleCompany(company);
    refChildren.checked = company.checked;

    master.checked = master.children.every((children) => children.checked);
    master.indeterminate = master.children.some(
      (children) => children.indeterminate && !master.checked
    );
    refMaster.checked = company.checked;
    this._onChange();
  }

  toogleAll(ref) {
    const isForceState = !this.allToogled();
    const forceValue = isForceState
      ? {
          colab: true,
          dependents: true,
        }
      : {
          colab: false,
          dependents: false,
          minor: false,
        };

    for (const company of this.companiesOptions) {
      if (company && company.children.length > 0) {
        for (const chidlren of company.children) {
          this.changeStateSingleCompany(chidlren, forceValue);
        }
        company.active = true;
        company.checked = company.children.every(
          (children) => children.checked
        );
        company.indeterminate = company.children.some(
          (children) =>
            (children.indeterminate || children.checked) && !company.checked
        );
        continue;
      }
      this.changeStateSingleCompany(company, forceValue);
    }
    ref.checked = isForceState;
    this._onChange();
  }

  onChangeStateCheckElements(
    company: CompanyCheckbox,
    refChildren,
    master?: CompanyCheckbox,
    refMaster?
  ) {
    if (!company.availableForDependents) {
      company.availableForMinors = false;
    }

    const {
      availableForEmployees: colab,
      availableForMinors: minor,
      availableForDependents: dependents,
    } = company;
    company.checked = colab && dependents && minor;
    company.indeterminate = (dependents || minor || colab) && !company.checked;

    refChildren.checked = company.checked;

    if (master) {
      master.checked = master.children.every((children) => children.checked);
      master.indeterminate = master.children.some(
        (children) =>
          (children.indeterminate || children.checked) && !master.checked
      );
      refMaster.checked = master.checked;
    }

    this._onChange();
  }

  private changeStateSingleCompany(
    company: CompanyCheckbox,
    forceState?: {
      colab: boolean;
      dependents: boolean;
      minor?: boolean;
    }
  ) {
    if (forceState) {
      company.availableForEmployees = forceState.colab;
      company.availableForDependents = forceState.dependents;
      company.availableForMinors =
        forceState.minor === false
          ? forceState.minor
          : company.availableForMinors;
    } else {
      const {
        availableForEmployees: colab,
        availableForMinors: minor,
        availableForDependents: dependents,
      } = company;
      company.availableForEmployees = colab && dependents ? false : true;
      company.availableForDependents = colab && dependents ? false : true;
      company.availableForMinors =
        colab && dependents && minor ? false : company.availableForMinors;

      if (!company.availableForDependents) {
        company.availableForMinors = false;
      }
    }

    company.active = true;
    company.checked =
      company.availableForEmployees &&
      company.availableForDependents &&
      company.availableForMinors;
    company.indeterminate =
      (company.availableForDependents ||
        company.availableForMinors ||
        company.availableForEmployees) &&
      !company.checked;
  }

  private _onChange() {
    this.allToogled();

    let list: CompanyCheckbox[] = [];
    for (const company of this.companiesOptions) {
      if (company.children && company.children.length > 0) {
        const childrens = company.children.filter(
          (c) => c.checked || c.indeterminate
        );
        list = list.concat(childrens);
        continue;
      }
      if (company.checked || company.indeterminate) {
        list.push(company);
      }
    }

    const companiesPermissions = this.formGroup.get(
      'companiesPermissions'
    ) as UntypedFormArray;

    while (companiesPermissions.length !== 0) {
      companiesPermissions.removeAt(0);
    }

    for (const company of list) {
      companiesPermissions.push(
        this.fb.group({
          id: company.id,
          availableForEmployees: company.availableForEmployees,
          availableForDependents: company.availableForDependents,
          availableForMinors: company.availableForMinors,
        })
      );
    }
  }

  private allToogled() {
    this.toogleAllModel = this.companiesOptions.every((company) => {
      if (company.children && company.children.length > 0) {
        return company.children.every(
          (children) => children.indeterminate || children.checked
        );
      }
      return company.indeterminate || company.checked;
    });
    return this.toogleAllModel;
  }
}
